<div class="product-promotion-container d-flex flex-column">
    <div class="product-promotion-content">
        <mat-dialog-content>
            <div><label class="mt-3">{{ 'PRODUCT_PROMOTION_LABEL' | translate }}</label></div>
            <div [formGroup]="productPromotionForm" trackChanges>
                <fieldset class="mt-3 program-authorization-section">
                    <legend class="mb-1">{{ 'PRODUCT_PROMOTION_PROGRAM_AUTHORIZATION' | translate }}</legend>
                    <div class="row">
                        <div class="col-sm-2">
                            <label>{{ 'PRODUCT_PROMOTION_AUTHORIZATION_CODE' | translate }}:</label>
                        </div>
                        <div class="col-sm-2">
                            <mat-form-field appearance="outline" class="col-sm-12" [class.readonly-field]="isReadOnly">
                                <input [readonly]="isReadOnly" matInput formControlName="authorizationCode" maxlength="13"
                                    (input)="onAuthorizationCodeInput($event)">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-1"></div>
                        <div class="col-sm-2">
                            <button mat-button mat-raised-button color="primary"
                                [disabled]="!getAssignedMaterialValue() || isReadOnly" *ngIf="!showStatusBtn"
                                (click)="onRequestBtnClick()">{{'PRODUCT_PROMOTION_REQUEST_BUTTON' |
                                translate}}</button>
                            <button mat-button mat-raised-button color="primary"
                                [disabled]="!getAssignedMaterialValue() || isReadOnly" *ngIf="showStatusBtn"
                                (click)="onRequestBtnClick(true)">{{'PRODUCT_PROMOTION_STATUS_BUTTON' |
                                translate}}</button>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="col-sm-2">
                            <label>{{ 'PRODUCT_PROMOTION_ALLOWABLE_DISCOUNT_DOLLARS' | translate }}</label>
                        </div>
                        <div class="col-sm-2">
                            <mat-form-field appearance="outline" class="col-sm-12" [class.readonly-field]="isReadOnly">
                                <input [readonly]="isReadOnly" matInput [appNumericMask] = "numericFieldsConfig.allowableDiscountDollarsConfig" class="text-right" placeholder="0.00"
                                    formControlName="allowableDiscountDollars">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <label>{{ 'PRODUCT_PROMOTION_ALLOWABLE_DISCOUNT_PERCENTAGE' | translate }}</label>
                        </div>
                        <div class="col-sm-2">
                            <mat-form-field appearance="outline" class="col-sm-5" [class.readonly-field]="isReadOnly">
                                <input [readonly]="isReadOnly" matInput [appNumericMask] = "numericFieldsConfig.allowableDiscountPercentageConfig" [showStepper]="true" class="text-right"
                                    formControlName="allowableDiscountPercentage">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row col-sm-8">
                        <label>{{ 'PRODUCT_PROMOTION_ASSIGN_MATERIAL_DISCOUNT' | translate }}:</label>
                        <div class="row col-sm-12 px-0">
                            <div class="col-sm-3">
                            <mat-form-field appearance="outline" class="col-sm-12" [class.readonly-field]="isReadOnly"
                                *ngIf="showMaterialDropdown(); else noMaterialDropdown">
                                    <mat-select formControlName="assignMaterialDiscountDropdown" [disabled]="isReadOnly"
                                        (selectionChange)="assignedMaterialDiscountDropDownChanged()">
                                        <mat-option
                                            *ngFor="let material of assignedMaterialsList; trackBy: trackByMaterialId"
                                            [value]="material.materialId">{{material.materialType}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <ng-template #noMaterialDropdown>
                                    <label>{{getFormControlValue('assignMaterialDiscountDropdown')}}</label>
                                </ng-template>
                            </div>
                            <div class="row col-sm-4 px-0">
                                <div class="col-sm-auto">
                                    <label>{{ 'PRODUCT_PROMOTION_DISCOUNT' | translate }}</label>
                                </div>
                                <div class="col-sm-6 width-col-sm-6 pe-0">
                                    <mat-form-field appearance="outline" class="col-sm-12" [class.readonly-field]="isReadOnly">
                                        <input matInput [appNumericMask] = "numericFieldsConfig.assignMaterialDiscountConfig" [showStepper] = "true" class="text-right"
                                            formControlName="assignMaterialDiscount" [readonly]="isReadOnly">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="width-4"></div>
                            <div class="col-sm-2">
                                <button mat-button mat-raised-button color="primary" [disabled]="!enableApplyBtn() || isReadOnly"
                                    (click)="onApplyBtnClick()">{{'PRODUCT_PROMOTION_APPLY_BUTTON' |
                                    translate}}</button>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="mt-3 applied-discounts-container">
                    <legend class="mb-1">{{ 'PRODUCT_PROMOTION_APPLIED_DISCOUNTS' | translate }}</legend>
                    <div class="row mb-2 ms-1" *ngFor="let discount of appliedDiscountsList; let i = index">
                        <div class="col-sm-1 width-col-sm-1 text-center pt-1">
                            {{ i + 1 }}.
                        </div>
                        <div class="col-sm-2 col-border me-2 text-center pt-1">{{ discount.authCode }}</div>
                        <div class="col-sm-2 col-border me-2 text-center pt-1">{{ discount.materialDiscountSelected }}
                        </div>
                        <div class="col-sm-1 col-border text-center pt-1">{{ discount.discount | decimalPrecision }}%</div>
                        <div class="col-sm-1">
                            <button mat-button mat-raised-button color="warn" (click)="onRemoveBtnClick(discount)" [disabled]="isReadOnly">{{
                                'PRODUCT_PROMOTION_REMOVE_BUTTON' | translate }}</button>
                        </div>
                    </div>
                </fieldset>
            </div>
        </mat-dialog-content>
    </div>
    <div class="product-promotion-footer d-flex justify-content-end">
        <button mat-raised-button color="warn" (click)="onClose()">{{ 'CLOSE' | translate }}</button>
    </div>
</div>